"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileOutlined = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.ProfileOutlined = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M21.3126 10.6877C21.3126 13.6218 18.9341 16.0003 16 16.0003C13.066 16.0003 10.6875 13.6218 10.6875 10.6877C10.6875 7.75356 13.066 5.375 16 5.375C18.9341 5.375 21.3126 7.75356 21.3126 10.6877ZM19.3126 10.6877C19.3126 12.5172 17.8295 14.0003 16 14.0003C14.1706 14.0003 12.6875 12.5172 12.6875 10.6877C12.6875 8.85808 14.1706 7.375 16 7.375C17.8295 7.375 19.3126 8.85808 19.3126 10.6877Z", fillRule: "evenodd" }),
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M26.2639 25.252C26.4457 25.896 26.5682 26.5647 26.6251 27.252H5.375C5.43187 26.5647 5.55437 25.896 5.73624 25.252C6.99768 20.7857 11.1152 17.5117 16.0001 17.5117C20.8849 17.5117 25.0024 20.7857 26.2639 25.252ZM16.0001 19.5117C19.7712 19.5117 22.9746 21.9106 24.1654 25.252H7.83467C9.02549 21.9106 12.2289 19.5117 16.0001 19.5117Z", fillRule: "evenodd" }))),
        size === 'medium' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M16.2501 7.75013C16.2501 10.0974 14.3473 12.0003 12 12.0003C9.6528 12.0003 7.75 10.0974 7.75 7.75013C7.75 5.40285 9.6528 3.5 12 3.5C14.3473 3.5 16.2501 5.40285 16.2501 7.75013ZM14.7501 7.75013C14.7501 9.26902 13.5188 10.5003 12 10.5003C10.4813 10.5003 9.25 9.26902 9.25 7.75013C9.25 6.23124 10.4813 5 12 5C13.5188 5 14.7501 6.23124 14.7501 7.75013Z", fillRule: "evenodd" }),
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M20.2385 19.5017C20.3689 19.986 20.4574 20.4874 20.5 21.0017H3.5C3.54259 20.4874 3.63112 19.986 3.76151 19.5017C4.73714 15.8779 8.05594 13.21 12 13.21C15.9441 13.21 19.2629 15.8779 20.2385 19.5017ZM12 14.71C15.11 14.71 17.7446 16.7205 18.6724 19.5017H5.32757C6.25544 16.7205 8.88997 14.71 12 14.71Z", fillRule: "evenodd" })))));
});
exports.ProfileOutlined.displayName = 'ProfileOutlined';
//# sourceMappingURL=ProfileOutlined.js.map